export default "__VITE_ASSET__Bb6lhD8E__"